export default __webpack_public_path__ + "static/media/chart_white.45ea9aa7.svg";